module.exports = __webpack_public_path__ + "img/abc_inventory_analysis.3c1a7321.svg";